<template>
	<div style="min-height: 70vh; max-height: 80vh">
		<vx-card :title="null">
			<vs-row vs-w="12">
				<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
					<div class="vx-row mb-6">
						<div class="vx-col w-full md:w-1/2">
							<label class="g-label--normal" v-text="$t('Permissions.FormInputPermissionName')"></label>
							<vs-input
								class="w-full"
								v-model="permission.name"
								name="name"
								v-validate="{required: true, regex: /^[A-Za-z\s_]+$/}"
							/>
							<span
								class="text-danger text-sm"
								v-show="errors.has('name')"
								v-text="$t('Permissions.ValidMessages.ValidPermissionName')"
							></span>
						</div>
						<div class="vx-col w-full md:w-1/2">
							<label
								class="g-label--normal"
								v-text="$t('Permissions.FormInputPermissionDescription')"
							></label>
							<vs-input
								class="w-full"
								v-model="permission.description"
								name="description"
								v-validate="{required: true}"
							/>
							<span
								class="text-danger text-sm"
								v-show="errors.has('description')"
								v-text="$t('Permissions.ValidMessages.ValidPermissionDescription')"
							></span>
						</div>
					</div>
					<div class="vx-row mb-6">
						<div class="vx-col w-full md:w-2/2">
							<label class="g-label--normal" v-text="$t('Permissions.FormInputRoles')"></label>
							<v-select
								multiple
								label="name"
								v-model="rolesSelected"
								:closeOnSelect="false"
								:options="listRoles"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:placeholder="$t('Select')"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
								</template>
							</v-select>
						</div>
					</div>
					<div class="vx-row float-right">
						<div class="vx-col w-full">
							<vs-button
								color="danger"
								type="border"
								class="mr-3 mb-2"
								v-if="editable"
								@click.stop="cancelEdit()"
								>{{ $t("Cancel") }}
							</vs-button>
							<vs-button
								id="btn-submit-company"
								color="success"
								class="mb-2"
								:disabled="isFormValid"
								@click="submitForm"
							>
								{{ $t("Save") }}
							</vs-button>
						</div>
					</div>
				</vs-col>
			</vs-row>
		</vx-card>
	</div>
</template>

<script>
import modulePermissions from "@/store/permissions/modulePermissions.js";
import vSelect from "vue-select";

export default {
	name: "PermissionsForm",
	components: {
		vSelect,
	},
	props: {
		permission: Object,
		editable: Boolean,
	},
	data() {
		return {
			//Permisos seleccionados
			rolesSelected: [],
		};
	},
	computed: {
		// Retorna los roles encontrados en el state
		listRoles() {
			return this.$store.state.modulePermissions.roles;
		},
		// Retorna las relaciones Role-Permiso encontrada en el state
		listRolePermission() {
			return this.$store.state.modulePermissions.role_permissions;
		},
		// Deshabilita o habilita el boton submit a partir de la validez de los campos
		isFormValid() {
			return this.errors.any();
		},
	},
	methods: {
		// Abrir load
		openLoading() {
			this.$vs.loading();
		},
		// Cerrar load
		closeLoading() {
			this.$vs.loading.close();
		},
		// Limpiar formulario
		clearForm() {
			this.rolesSelected = [];
			this.$emit("clearPermissionEmit");
			this.$validator.reset();
		},
		// Actualizar permisos
		updatePermissionsList() {
			this.$emit("updatePermissionsEmit");
		},
		// Submit al formulario
		submitForm() {
			this.$validator.validateAll().then((result) => {
				// Si el resultado es falso, los campos no son validos
				if (!result) {
					// Valida los campos para poder visualizar los mensaje de error
					this.$validator.validate();
				} else {
					// Los campos del formulario son correctos
					this.correctPermission();
				}
			});
		},
		// Permiso correcto
		correctPermission() {
			// Creacion del objeto
			let objectFinal = {};
			let arrayFinal = [];
			// Si el formulario tiene permisos seleccionados
			if (this.rolesSelected.length !== 0) {
				// Inserta los id de los roles seleccionados en el objeto
				Object.values(this.rolesSelected).forEach((val) => {
					arrayFinal.push(val.id);
				});
				objectFinal.role_id = arrayFinal;
			} else {
				// Sino envia el campo vacio, de lo contrario no actualizara los roles
				objectFinal.role_id = [];
			}
			// Se agrega el nombre del Rol al objeto
			objectFinal.name = this.permission.name;
			// Se agrega la descripción del Rol al objeto
			objectFinal.description = this.permission.description;
			// Se abre el Load
			this.openLoading();
			// Se define si se esta editando el rol o se esta modificando, determinado por el prop this.editable
			if (this.editable) {
				// Actualiza Rol - se envia el objeto construido anteriormente al metodo
				this.updateMethod(objectFinal);
			} else {
				// Crea el Rol - se envia el objeto construido anteriormente al metodo
				this.createMethod(objectFinal);
			}
		},
		// Metodo para crear rol
		createMethod(object) {
			// Llama la accion Vuex, "addPermission" y envia el objeto
			this.$store
				.dispatch("modulePermissions/addPermission", JSON.stringify(object))
				.then((res) => {
					// Respuesta exitosa
					// Cierra el load
					this.closeLoading();
					// Limpia el formulario
					this.clearForm();
					// Cancela la edición
					this.cancelEdit();
					// Actualiza la los roles
					this.updatePermissionsList();
					// Muestra mensaje de exito
					this.$vs.notify({
						color: "success",
						title: this.$t("Permissions.Create.Title"),
						text: this.$t("Permissions.Create.Text"),
					});
				})
				.catch((err) => {
					// Respuesta erronea
					// Cierra el load
					this.closeLoading();
					// Muestra un mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("Permissions.Create.TitleError"),
						text: this.$t("Permissions.Create.TextError"),
					});
					throw new Error(err);
				});
		},
		// Metodo que actualiza el permiso
		updateMethod(object) {
			// inserta el id en el objeto para utilizarlo en la url del PUT
			object.id = this.permission.id;
			// Llama la acción Vuex "updateRole" y envia el objeto
			this.$store
				.dispatch("modulePermissions/updatePermission", object)
				.then((res) => {
					// Respuesta exitosa
					// cierra el load
					this.closeLoading();
					// limpia el formulario
					this.clearForm();
					// Cancela la edición
					this.cancelEdit();
					// Actualiza los permisos
					this.updatePermissionsList();
					// Muestra mensaje de exito
					this.$vs.notify({
						color: "success",
						title: this.$t("Permissions.Update.Title"),
						text: this.$t("Permissions.Update.Text"),
					});
				})
				.catch((err) => {
					// Respuesta erronea
					// Cierra load
					this.closeLoading();
					// Muestra mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("Permissions.Update.TitleError"),
						text: this.$t("Permissions.Update.TextError"),
					});
					throw new Error(err);
				});
		},
		// Cancela edición en curso
		cancelEdit() {
			// Limpia el formulario
			this.clearForm();
			// Emite la accion cancelar al componente padre "Permission.vue"
			this.$emit("cancelEditEmit");
		},
		// Metodo para renombrar propiedades de un objeto (Se utiliza más adelante)
		renameProperty(obj, oldName, newName) {
			obj[newName] = obj[oldName];
			delete obj[oldName];
			//obj[newName] = ''
			return obj;
		},
	},
	created() {
		// Registra modulo
		if (!modulePermissions.isRegistered) {
			this.$store.registerModule("modulePermissions", modulePermissions);
			modulePermissions.isRegistered = true;
		}
		// Abre el load
		this.openLoading();
		// Consulta los roles
		this.$store
			.dispatch("modulePermissions/getRoles")
			.then((res) => {
				// Respuesta exitosa
				// Cierra el load
				this.closeLoading();
			})
			.catch((err) => {
				// Respuesta erronea
				// cierra el load
				this.closeLoading();
				// Muestra mensaje de error
				this.$vs.notify({
					color: "danger",
					title: this.$t("Permissions.GetRoles.TitleConsultPermissionsError"),
					text: this.$t("Permissions.GetRoles.TextConsultPermissionsError"),
				});
				throw new Error(err);
			});

		if (this.editable) {
			let permissionPermissionsValid = [];
			// Recorre las relaciones rol-permiso del state
			Object.values(this.listRolePermission).forEach((val2) => {
				// Si el permission_id de la relacion corresponde corresponde al id del permiso seleccionado
				if (val2.permission_id == this.permission.id) {
					permissionPermissionsValid.push({...val2});
				}
			});
			let cont = 0;
			// Para que el multi-select funcione correctamente debe tener los valores llave que utiliza la consulta de los roles
			Object.keys(permissionPermissionsValid).forEach((key) => {
				this.renameProperty(permissionPermissionsValid[cont], "role_name", "name");
				this.renameProperty(permissionPermissionsValid[cont], "role_id", "id");
				cont++;
			});

			// Al tener el arreglo de roles seleccionados se le asigna al options del multi-select, el cual selecciona los permisos
			this.rolesSelected = permissionPermissionsValid;
		}
	},
};
</script>
